import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { io } from 'socket.io-client';

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const [notificaciones, setNotificaciones] = useState([]);
  const [noLeidas, setNoLeidas] = useState(0);
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const socketUrl = process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL.replace('/api', '')
      : window.location.origin;

    const s = io(socketUrl, {
      auth: { token },
      transports: ['websocket'],
    });

    socketRef.current = s;
    setSocket(s);

    const agregarNotificacion = (incidente, tipo) => {
      const nueva = { ...incidente, _tipo: tipo, _leida: false, _ts: Date.now() };
      setNotificaciones(prev => [nueva, ...prev].slice(0, 50));
      setNoLeidas(prev => prev + 1);
    };

    s.on('nuevo_incidente',      (data) => agregarNotificacion(data, 'nuevo'));
    s.on('incidente_actualizado',(data) => {
      if (data?.estado === 'cerrado') return; // no notificar cuando se finaliza
      agregarNotificacion(data, 'actualizado');
    });

    return () => {
      s.disconnect();
    };
  }, []);

  const marcarTodasLeidas = () => {
    setNotificaciones(prev => prev.map(n => ({ ...n, _leida: true })));
    setNoLeidas(0);
  };

  return (
    <SocketContext.Provider value={{ notificaciones, noLeidas, marcarTodasLeidas, socket }}>
      {children}
    </SocketContext.Provider>
  );
};

SocketProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useSocket = () => useContext(SocketContext);
